import { CustomerList } from "./CustomerList";
import { CustomerDetails } from "./CustomerDetails";
import { useSmartrrFlags } from "@smartrr/shared/LaunchDarkly";
import { LegacyAdminCustomersRoute } from "./legacy";

export function AdminCustomersRoute({ customerId }: { customerId?: string }): JSX.Element {
  const { newCustomerTable } = useSmartrrFlags();

  if (newCustomerTable) {
    if (customerId) {
      return <CustomerDetails customerShopifyId={customerId} />;
    }

    return <CustomerList />;
  }

  return <LegacyAdminCustomersRoute customerId={customerId} />;
}
